// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__LBFOo","main":"Layout_main__EYHs9","footer":"Layout_footer__E1_6_","title":"Layout_title__VfIcT","description":"Layout_description__GdhdA"};